import { render } from "./header2.vue?vue&type=template&id=465aa8d6&scoped=true"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"

import "./header2.vue?vue&type=style&index=0&id=465aa8d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465aa8d6"]])

export default __exports__